import { AfterViewInit, Component } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  baseCssConfigStyle,
  BaseCssProperties,
  ProviderClass,
} from '@finxone-platform/shared/sys-config-types';
import { BaseComponent } from '../base/base.component';
import { Subject } from 'rxjs';

declare global {
  interface Window {
    GoCardlessCompliance: {
      render(billingRequestId: string, flowType: string, options: { parentId: string; theme: string }): void;
    };
  }
}

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-pisp-gocardless-compliance-widget',
  templateUrl: './pisp-gocardless-compliance-widget.component.html',
  styleUrls: ['./pisp-gocardless-compliance-widget.component.scss'],
})
export class PispGocardlessComplianceWidgetComponent extends BaseComponent implements AfterViewInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();

  public parentId = `gc-compliance-${Math.random().toString(20).substring(2, 6)}`;
  public isAppbuilder: boolean;
  public customPaymentPagesEnabled: boolean;
  public textContentStyle: baseCssConfigStyle;

  get parentDivStyle(): Record<string, string> {
    return {
      display: this.isAppbuilder ? 'none' : 'auto',
      ...this.textContentStyle,
    };
  }

  constructor(private dataIn: ProviderClass<any>, private configService: ConfigService) {
    super();

    const script = document.createElement('script');

    this.isAppbuilder = this.configService.getActiveConfigType().isWorkflow ?? false;
    this.customPaymentPagesEnabled = this.configService?.config?.goCardlessEnabledCustomPaymentPages ?? false;

    if (this.configService?.config?.goCardlessEnvironment === 'sandbox' || this.isAppbuilder) {
      script.setAttribute('environment', 'sandbox');
    }
    script.src = 'https://custom-payment-page-tools.gocardless.com/compliance.js';
    document.head.prepend(script);
  }

  ngAfterViewInit(): void {
    if (this.dataIn.attri) {
      this.textContentStyle = this.configService.getSpecificBaseCssStyle(this.dataIn.attri, [
        BaseCssProperties.COLORS_V2,
        BaseCssProperties.BORDER_V2,
        BaseCssProperties.FONT_SIZE,
        BaseCssProperties.TEXTALIGN,
        BaseCssProperties.MARGIN,
        BaseCssProperties.TEXT_FONT_STYLE,
      ]);
    }
    if (this.customPaymentPagesEnabled) {
      setTimeout(() => {
        // Extract the billing_request_id from the URL query parameters — put there by
        // reviewPispDeposit / the pisp banks listing widget when navigating to this page
        const billingRequestId = new URLSearchParams(window.location.search).get('billing_request_id');
        if (!billingRequestId) {
          console.error(
            'pisp-gocardless-compliance: billing_request_id missing from URL, compliance content not rendered',
          );
          return;
        }

        const theme = this.dataIn.attri.theme === 'dark' ? 'dark' : 'light';
        const options = {
          parentId: this.parentId,
          theme: theme,
        };
        (window as any).GoCardlessCompliance.render(billingRequestId, 'bank-authorisation', options);
      }, 1000);
    }
  }
}
